import React from 'react';

import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import MoreVertIcon from '@material-ui/icons/MoreVert';

import { useReportCardActionsStyles } from './report-card-actions.styles';

interface IReportCardActionsButtonProps {
  playerAssessmentId: string;
  // Omitted while busy, when the button is disabled.
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  busy?: boolean;
  menuOpen?: boolean;
}

// The 3-dot trigger of a player's report card menu, shared by the menu and by a row that loads it on demand.
export const ReportCardActionsButton = React.forwardRef<HTMLButtonElement, IReportCardActionsButtonProps>(
  ({ playerAssessmentId, onClick, busy = false, menuOpen = false }, ref) => {
    const classes = useReportCardActionsStyles();

    return (
      <Tooltip title="Report card actions" placement="left">
        <span>
          <IconButton
            ref={ref}
            id={`report-card-actions-${playerAssessmentId}`}
            className={classes.menuButton}
            onClick={onClick}
            disabled={busy}
            aria-label="Report card actions"
            aria-controls={menuOpen ? `report-card-menu-${playerAssessmentId}` : undefined}
            aria-haspopup="menu"
            aria-expanded={menuOpen ? 'true' : 'false'}
            size="small"
          >
            {busy ? <CircularProgress size={20} className={classes.loadingSpinner} /> : <MoreVertIcon />}
          </IconButton>
        </span>
      </Tooltip>
    );
  },
);
